import template from './refineExplainer.html';
import controller from './refineExplainerController';

function directive() {
  return {
    restrict: 'E',
    template,
    controller: 'refineExplainerController'
  };
}

export default function (ngModule) {
  ngModule.directive('refineExplainer', directive);
  controller(ngModule);
}
